import axios from './ApiConfig';

const MockAdapter = require('axios-mock-adapter');
const mockAdapter = new MockAdapter(axios, {delayResponse: 200});
if( 'true' != localStorage.getItem('useMockData') )
    mockAdapter.restore();

export default mockAdapter;
